module.exports = __webpack_public_path__ + "img/logo.683f39c4.png";